const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class AirForces extends Technology {
    constructor(){
        super(
            AirForces.GetAge(),
            AirForces.GetType(),
            AirForces.GetName(),
            12,
            7,
            {
                playerStateAltering:
                (playerState) => playerState.militaryCalculationDelegate.push({
                    Source: this,
                    Action: () => this.GetWorkerCount() * 5,
                })
                // Doubling an army for tactics: see Effects/Tactics.js
            }
        )
        // Strength of one unit
        this.multiplier = 5;
    }

    static GetInstance = () => new AirForces();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Military.AirForces;
    static GetType = () => TechnologyTypes.Military.AirForces;
}

module.exports = {
    AirForces,
}